document.addEventListener('DOMContentLoaded', function() {
  var collapsibles = document.querySelectorAll('#CollectionSidebar at-collapsible');
  collapsibles.forEach(function(collapsible) {
    var trigger = collapsible.querySelector('.collapsible-trigger');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-open');
    var content = collapsible.querySelector('.collapsible-content');
    content.classList.add('is-open');
    content.style.height = 'auto';

    var list = content.querySelector('ul');
    var items = list.children;
    var maxItems = 10;

    if (items.length > maxItems) {
      var showMoreLink = document.createElement('span');
      showMoreLink.textContent = 'Show more';
      showMoreLink.classList.add('show-more-link');
      showMoreLink.style.cursor = 'pointer';

      for (var i = maxItems; i < items.length; i++) {
        items[i].style.display = 'none';
      }

      list.appendChild(showMoreLink);

      showMoreLink.addEventListener('click', function() {
        for (var i = maxItems; i < items.length; i++) {
          items[i].style.display = 'block';
        }
        showMoreLink.style.display = 'none';
      });
    }
  });
});